export default __webpack_public_path__ + "static/media/logo-chrome.ff843e61.svg";